// Internal AG&WESTERN Rail Contacts
export const internalContacts = [
  {
    id: "aaron-gregory",
    name: "Aaron Gregory",
    email: "Aaron.gregory@agwesternrail.com",
    position: "Owner",
    department: "Executive",
    phone: "(866) 324-9378",
    avatar: null
  },
  {
    id: "madison-bailey",
    name: "Madison Bailey",
    email: "MadisonBailey.President@agwesternrail.com",
    position: "President",
    department: "Executive",
    phone: "(866) 324-9378",
    avatar: null
  },
  {
    id: "donovan-jones",
    name: "Donovan Jones",
    email: "DonovanJones.vicepresident@agwesternrail.com",
    position: "Vice President",
    department: "Executive",
    phone: "(866) 324-9378",
    avatar: null
  },
  {
    id: "lindsay-schneider",
    name: "Lindsay Schneider",
    email: "LindsaySchneider.CSO@agwesternrail.com",
    position: "Chief Secretary Officer",
    department: "Executive",
    phone: "(866) 324-9378",
    avatar: null
  },
  {
    id: "jennifer-major",
    name: "Jennifer Major",
    email: "JenniferMajor.CHRO@agwesternrail.com",
    position: "Chief Human Resources Officer",
    department: "Human Resources",
    phone: "(866) 324-9378",
    avatar: null
  },
  {
    id: "david-austin",
    name: "David Austin",
    email: "DavidAustin.CTO@agwesternrail.com",
    position: "Chief Technology Officer",
    department: "Information Technology",
    phone: "(866) 324-9378",
    avatar: null
  }
];

// External Partner Contacts
export const externalContacts = [
  {
    id: "norfolk-southern",
    name: "Norfolk Southern",
    email: "nscarrierrelations@nscorp.com",
    phone: null,
    description: "Carrier Relations",
    logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/u86e200f_IMG_0271.png",
    type: "Railroad Partner"
  },
  {
    id: "csx-transportation",
    name: "CSX Transportation",
    contacts: [
      {
        label: "Corporate Headquarters",
        phone: "904-359-3200",
        address: "500 Water Street, 15th Floor, Jacksonville, FL 32202"
      },
      {
        label: "Railroad Emergency",
        phone: "1-800-232-0144",
        emergency: true
      }
    ],
    logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/g8npeuue_IMG_0272.png",
    type: "Railroad Partner"
  },
  {
    id: "amtrak",
    name: "Amtrak",
    email: "intlhelp@amtrak.com",
    description: "International Help & Support",
    logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/ziyo2uak_IMG_0275.png",
    type: "Railroad Partner"
  },
  {
    id: "fra-support",
    name: "FRA Support",
    email: "Web@dot.gov",
    description: "Federal Railroad Administration",
    logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/exnd1auf_IMG_0027.png",
    type: "Government Agency"
  },
  {
    id: "stb",
    name: "Surface Transportation Board",
    website: "https://www.stb.gov/resources/need-assistance/",
    description: "STB Assistance & Resources",
    logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_western-rail-hub/artifacts/36jnwooz_IMG_0276.jpeg",
    type: "Government Agency"
  }
];
